module.exports = __webpack_public_path__ + "img/nucleicAcidDetectionImg.237275b1.png";